export default function formatCurrency(currency: string) {
  const cleanedValue = String(currency).replace(/[^0-9]/g, ''); // Remove non-numeric characters
  const floatValue = parseFloat(cleanedValue);
  const fractionValue = floatValue / 100; // Divide by 100 to treat it as a fraction of a unit
  const formattedValue = fractionValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formattedValue;
}
